import { GET_COUPON_FACILITY, GET_COUPON_FACILITY_SUCCESS, GET_COUPON_FACILITY_ERROR, GET_COUPON_FACILITY_EMPTY } from './../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCouponFacility = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_FACILITY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_COUPON_FACILITY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_COUPON_FACILITY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_COUPON_FACILITY_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCouponFacility;
